import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["tenantSettings", "globalSelectedShop", "featureToggles"]),
		isExtraAddOnsShown() {
			return this.filteredProducts ? this.addonsLimit < this.filteredProducts.length : this.addonsLimit < this.group.products.length;
		},
		addonsLimit() {
			return this.tenantSettings.additionsFoldingThreshold || 4;
		},
		newAddonsFlow() {
			return this.featureToggles.newAddonsDesignAndFlow && this.globalSelectedShop.shopOptions.newAddonsDesign;
		}
	}
};
